import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import {
  FileAsAStream,
  SmsBatchCreateRequest,
  SmsBatchCreateResponse,
  SmsBatchValidationResponse,
} from "@/api/backofficeRest/generated/model"
import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"

export interface ISmsBatchMutator {
  validate(): MutationResult<FileAsAStream, SmsBatchValidationResponse>
  create(): MutationResult<SmsBatchCreateRequest, SmsBatchCreateResponse>
}

class SmsBatchMutatorClass implements ISmsBatchMutator {
  validate(): MutationResult<FileAsAStream, SmsBatchValidationResponse> {
    return useMutation({
      ...BackofficeRestMutations.smsBatch.validate(),
      serializerFn: (data: FileAsAStream) => data,
      invalidateCache: false,
    })
  }

  create(): MutationResult<SmsBatchCreateRequest, SmsBatchCreateResponse> {
    return useMutation({
      ...BackofficeRestMutations.smsBatch.create(),
      serializerFn: (data: SmsBatchCreateRequest) => data,
      invalidateCache: false,
    })
  }
}

export const SmsBatchMutator = new SmsBatchMutatorClass()
